import { useTranslate } from "@similarweb/i18n-provider";
import { Tooltip } from "@similarweb/ui-components";

import { ExportCostTypeItem } from "app/pages/sales-intelligence/modules/quota/enums";

import { quotaKeys } from "../../utils/i18n";
import { QuotaTooltipContent } from "../QuotaTooltipContent/QuotaTooltipContent";
import QuotaTotalCost from "../QuotaTotalCost";

type Props = {
    isLowQuota: boolean;
    quota: number;
    withTooltip: boolean;
    onExportCostChange: VoidFunction;
    pricePerRecord: number;
    exportType?: ExportCostTypeItem;
};

const QuotaExportCostTag = ({
    isLowQuota,
    quota,
    withTooltip,
    onExportCostChange,
    pricePerRecord,
    exportType = ExportCostTypeItem.Excel,
}: Props) => {
    const { translate } = useTranslate();

    return (
        <Tooltip
            enabled={withTooltip}
            content={
                <QuotaTooltipContent
                    description={
                        exportType !== ExportCostTypeItem.Competitors
                            ? translate(quotaKeys.exportCostInfoDescription)
                            : translate(quotaKeys.exportCostCompetitorDescription, { cost: pricePerRecord })
                    }
                    buttonText={
                        exportType !== ExportCostTypeItem.Competitors
                            ? translate(quotaKeys.exportCostAdjustTitle)
                            : undefined
                    }
                    onClick={onExportCostChange}
                />
            }
        >
            <div>
                <QuotaTotalCost
                    isOutOfQuota={isLowQuota}
                    totalCost={quota}
                />
            </div>
        </Tooltip>
    );
};

export default QuotaExportCostTag;
